module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl3-75.a0073067.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl3-75.png
// module id = 3587
// module chunks = 11